import * as React from 'react';
import { Form, Tree } from 'antd';

import FormHeader from '../FormHeader';

interface DataSelectionProps {
    selectedDataPoint: string;
    setSelectedDataPoint: (value: string) => void;
}

const treeData = [
    {
        title: 'Daily Closing Value',
        key: 'Daily_Closing_Value',
        isLeaf: true,
    },
];

const DataSelection: React.FC<DataSelectionProps> = ({ selectedDataPoint, setSelectedDataPoint }: DataSelectionProps) => {
    return (
        <>
            <FormHeader title="Data Selection" />
            <Form.Item name="dataSelection">
                <div>
                    <Tree
                        style={{ width: '100%' }}
                        treeData={treeData}
                        selectedKeys={[selectedDataPoint]}
                        onSelect={(selectedKeys, info) => {
                            if (selectedKeys.length > 0 && info.node.isLeaf) {
                                const selected = selectedKeys[0].toString();
                                setSelectedDataPoint(selected);
                            } else {
                                setSelectedDataPoint(selectedDataPoint);
                            }
                        }}
                        selectable
                        defaultExpandAll
                    />
                </div>
            </Form.Item>
        </>
    );
};

export default DataSelection; 